/* eslint-disable jsx-a11y/control-has-associated-label */
import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import Collapsible from 'react-collapsible';
import { FaFile, FaFileCsv, FaFilePdf } from 'react-icons/fa';
import {
  getMyAccount,
  getTheme,
  getMyStatements,
  getMyStatementFiles,
} from '../api/queries';
// import { hasAdminRights } from '../auth/shared';
// import { hasAdminRights } from '../auth/shared';
import { themeVariables } from '../helpers/helpers';
import AppState from '../store/appstate';
import ButtonPrimary from './buttonPrimary';
import SmallButton from './smallButton';
// import ButtonPrimaryText from './buttonPrimaryText';
import LoadingSmall from './loadingSmall';
import Table from './table';

const StatementsTable = () => {
  const { t } = useTranslation('other');
  const selectedAccount = AppState.useState((s) => s.selectedAccount);
  const myAccount = getMyAccount({
    artistaccountcode: selectedAccount,
  });
  const statements = getMyStatements({ aac: selectedAccount });

  const [uuid, setUuid] = useState(null);
  const [downloads, setDownloads] = useState([]);
  const files = getMyStatementFiles({ aac: selectedAccount, suid: uuid });
  const theme = getTheme({
    cataloguecode: myAccount?.data?.cataloguecode,
  });
  const { highlightColour } = themeVariables(theme);

  useEffect(() => {
    if (
      files.isSuccess
      && files?.data?.statementsFiles
      && downloads.length === 0
    ) {
      if (files?.data?.statementsFiles.length === 0) {
        return;
      }

      const fileArray = JSON.parse(
        JSON.stringify(files?.data?.statementsFiles),
      );
      // sort by filename

      fileArray.sort(
        (a, b) => a.mimetype - b.mimetype || b.filename - a.filename,
      );
      setDownloads(fileArray);
    }
  }, [files.isSuccess, downloads]);

  const getTypeIcon = (mime) => {
    switch (mime) {
      case 'application/pdf':
        return (
          <div className="text-xxs md:text-sm flex flex-row items-center">
            <FaFilePdf />
            {' '}
            <p className="sm:hidden pl-1">PDF</p>
          </div>
        );
      case 'text/csv':
        return (
          <div className="text-xxs md:text-sm flex flex-row items-center">
            <FaFileCsv />
            {' '}
            <p className="sm:hidden pl-1">CSV</p>
          </div>
        );
      default:
        return (
          <div className="text-xxs md:text-sm flex flex-row items-center">
            <FaFile />
          </div>
        );
    }
  };

  const columns = React.useMemo(() => [
    {
      Header: t('common:_name'),
      accessor: 'name',
      width: '25%',
      id: 'colStatementName',
      Cell: ({ row }) => (
        <>
          <p>{row?.values?.colStatementName}</p>
          <small className="hidden md:inline">
            {'Published '}
            {row?.original.publishdate
              && row?.original.publishdate !== '0000-00-00'
              ? format(Date.parse(row?.original.publishdate), 'yyyy/MM/dd')
              : 'unknown'}
          </small>
        </>
      ),
    },
    {
      Header: t('other:closing-balance'),
      accessor: 'closingbalance',
      width: '25%',
      id: 'colStatementBalance',
      Cell: ({ row }) => (
        <p className="text-sm">
          &pound;
          {Number(row.values?.colStatementBalance).toFixed(2)}
        </p>
      ),
    },
    {
      Header: t('other:statement-table-header-files'),
      accessor: 'hasstatement',
      width: '50%',
      id: 'colStatementFiles',
      disableSortBy: true,
      Cell: ({ row }) => (
        <div className="view-files-container md:grid-flow-col">
          {row?.values?.colStatementFiles && (
            <ButtonPrimary
              id="btnStatementsViewFiles"
              onClick={() => {
                setDownloads([]);
                setUuid(row?.original.uniqueidentifier);
              }}
            >
              <p>{t('other:view-files-button')}</p>
            </ButtonPrimary>
          )}
          {uuid === row?.original.uniqueidentifier && (
            <div className="statement-buttons-container mt-2 sm:mt-1 flex flex-wrap justify-start md:justify-center">
              {files.isLoading && <LoadingSmall />}
              {files.isSuccess && (
                <>
                  {downloads.map((d) => (
                    <SmallButton
                      onClick={() => {
                        window.open(d.presignedurl, '_blank');
                      }}
                    >
                      <div className="flex items-center">
                        <span className="mr-2 text-sm">
                          {getTypeIcon(d.mimetype)}
                        </span>
                        <span className="hidden sm:inline">{d.filename}</span>
                      </div>
                    </SmallButton>
                  ))}
                </>
              )}
            </div>
          )}
        </div>
      ),
    },
  ]);
  return (
    <>
      <div className="w-full p-8 bg-white rounded-lg">
        {statements.isLoading && <LoadingSmall />}
        {statements.data?.total >= 1
          ? (
            <div>
              <Table
                area="statements"
                data={statements?.data?.statements}
                columns={columns}
                min={5}
                highlightColour={highlightColour}
                revealComponent={null}
                searchSuffix={t('other:statements-search-suffix')}
                bgClass="bg-white rounded-lg p-0"
              />
            </div>
          )
          : (
            <div>
              <p>No statements available.</p>
            </div>
          )}
      </div>
    </>
  );
};

export default StatementsTable;
